import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ProductDetail.css';
import { useTranslation } from 'react-i18next';

// --- СЛОВАРИ ПЕРЕВОДОВ ---

const categoryTranslations = {
    "Готовые продукты": { en: "Ready-made products", ru: "Готовые продукты" },
    "Готовый продукт": { en: "Ready product", ru: "Готовый продукт" },
    "Грибы": { en: "Mushrooms", ru: "Грибы" },
    "Зерновые": { en: "Cereals", ru: "Зерновые" },
    "Крахмалосодержащие": { en: "Starchy foods", ru: "Крахмалосодержащие" },
    "Масло": { en: "Oil", ru: "Масло" },
    "Мед": { en: "Honey", ru: "Мед" },
    "Молочный": { en: "Dairy", ru: "Молочный" },
    "Мука": { en: "Flour", ru: "Мука" },
    "Мясной": { en: "Meat", ru: "Мясной" },
    "Напитки": { en: "Drinks", ru: "Напитки" },
    "Напиток": { en: "Drink", ru: "Напиток" },
    "Овощи": { en: "Vegetables", ru: "Овощи" },
    "фрукты": { en: "fruits", ru: "фрукты" },
    "ягоды и продукты их переработки (кроме соков)": { en: "berries and their processed products (except juices)", ru: "ягоды и продукты их переработки (кроме соков)" },
    "Овощи, фрукты, ягоды и продукты их переработки (кроме соков)": { en: "Vegetables, fruits, berries and their processed products (except juices)", ru: "Овощи, фрукты, ягоды и продукты их переработки (кроме соков)" },
    "Орехи": { en: "Nuts", ru: "Орехи" },
    "Рыба": { en: "Fish", ru: "Рыба" },
    "Сахаросодержащий": { en: "Sugar-containing", ru: "Сахаросодержащий" },
    "Сыпучий пищевой продукт": { en: "Bulk food product", ru: "Сыпучий пищевой продукт" },
    "Бобовые": { en: "Legumes", ru: "Бобовые" },
    "Консервы": { en: "Canned goods", ru: "Консервы" },
    "Крупы": { en: "Grain products", ru: "Крупы" },
    "Молочная продукция": { en: "Dairy products", ru: "Молочная продукция" },
    "Паста": { en: "Pasta", ru: "Паста" },
    "Сладости": { en: "Sweets", ru: "Сладости" },
    "Субпродукты": { en: "Offal", ru: "Субпродукты" },
    "Фасоль": { en: "Beans", ru: "Фасоль" },
    "Фрукты": { en: "Fruits", ru: "Фрукты" },
    "Яйца": { en: "Eggs", ru: "Яйца" }
};

const regionTranslations = {
    "Джалал-Абадская область": { en: "Jalal-Abad Region", ru: "Джалал-Абадская область" },
    "Иссык-Кульская область": { en: "Issyk-Kul Region", ru: "Иссык-Кульская область" },
    "Кыргызстан": { en: "Kyrgyzstan", ru: "Кыргызстан" },
    "Нарынская область": { en: "Naryn Region", ru: "Нарынская область" },
    "Ошская область": { en: "Osh Region", ru: "Ошская область" },
    "Таласская область": { en: "Talas Region", ru: "Таласская область" },
    "Чуйская область": { en: "Chuy Region", ru: "Чуйская область" },
    "Баткенская область": { en: "Batken Region", ru: "Баткенская область"}
};

const nutrientTranslations = {
    "Энерг. ценность": { en: "Energy Value", ru: "Энерг. ценность" },
    "Энергетическая ценность": { en: "Energy Value", ru: "Энергетическая ценность" },
    "Влажность": { en: "Moisture", ru: "Влажность" },
    "Белок": { en: "Protein", ru: "Белок" },
    "Жир": { en: "Fat", ru: "Жир" },
    "Зольность": { en: "Ash Content", ru: "Зольность" },
    "Зольность, %": { en: "Ash Content, %", ru: "Зольность, %" },
    "Углеводы": { en: "Carbohydrates", ru: "Углеводы" },
    "Углеводы, %": { en: "Carbohydrates, %", ru: "Углеводы, %" },
    "Массовая доля влаги, %": { en: "Moisture content, %", ru: "Массовая доля влаги, %" },
    "Массовая доля белка, %": { en: "Protein content, %", ru: "Массовая доля белка, %" },
    "Массовая доля жира, %": { en: "Fat content, %", ru: "Массовая доля жира, %" },
    "Массовая доля растворимых сухих веществ, %": { en: "Soluble dry matter, %", ru: "Массовая доля растворимых сухих веществ, %" },
    "Массовая доля аскорбиновой кислоты, г/дм3": { en: "Ascorbic acid, g/dm³", ru: "Массовая доля аскорбиновой кислоты, г/дм3" }
};

const mineralTranslations = {
    "Кальций": { en: "Calcium", ru: "Кальций" },
    "Натрий": { en: "Sodium", ru: "Натрий" },
    "Калий": { en: "Potassium", ru: "Калий" },
    "Фосфор": { en: "Phosphorus", ru: "Фосфор" },
    "Марганец": { en: "Manganese", ru: "Марганец" },
    "Цинк": { en: "Zinc", ru: "Цинк" },
    "Скандий": { en: "Scandium", ru: "Скандий" },
    "Медь": { en: "Copper", ru: "Медь" },
    "Железо": { en: "Iron", ru: "Железо" },
    "Йод": { en: "Iodine", ru: "Йод" },
    "Бор": { en: "Boron", ru: "Бор" },
    "Литий": { en: "Lithium", ru: "Литий" },
    "Алюминий": { en: "Aluminium", ru: "Алюминий" },
    "Магний": { en: "Magnesium", ru: "Магний" },
    "Ванадий": { en: "Vanadium", ru: "Ванадий" },
    "Нитрий": { en: "Nickel", ru: "Нитрий" },
    "Ковальт": { en: "Cobalt", ru: "Ковальт" },
    "Хром": { en: "Chromium", ru: "Хром" },
    "Олово": { en: "Tin", ru: "Олово" },
    "Барий": { en: "Barium", ru: "Барий" }
};

const aminoAcidTranslations = {
    "Аланин": { en: "Alanine", ru: "Аланин" },
    "Аргинин": { en: "Arginine", ru: "Аргинин" },
    "Аспарагин": { en: "Asparagine", ru: "Аспарагин" },
    "Аспарагиновая кислота": { en: "Aspartic acid", ru: "Аспарагиновая кислота" },
    "Аспарагиновая к-та": { en: "Aspartic acid", ru: "Аспарагиновая к-та" },
    "Валин": { en: "Valine", ru: "Валин" },
    "Гистидин": { en: "Histidine", ru: "Гистидин" },
    "Глицин": { en: "Glycine", ru: "Глицин" },
    "Глутамин": { en: "Glutamine", ru: "Глутамин" },
    "Глутаминовая кислота": { en: "Glutamic acid", ru: "Глутаминовая кислота" },
    "Глутаминовая к-та": { en: "Glutamic acid", ru: "Глутаминовая к-та" },
    "Изолейцин": { en: "Isoleucine", ru: "Изолейцин" },
    "Лейцин": { en: "Leucine", ru: "Лейцин" },
    "Лизин": { en: "Lysine", ru: "Лизин" },
    "Метионин": { en: "Methionine", ru: "Метионин" },
    "Пролин": { en: "Proline", ru: "Пролин" },
    "Серин": { en: "Serine", ru: "Серин" },
    "Тирозин": { en: "Tyrosine", ru: "Тирозин" },
    "Треонин": { en: "Threonine", ru: "Треонин" },
    "Триптофан": { en: "Tryptophan", ru: "Триптофан" },
    "Фенилаланин": { en: "Phenylalanine", ru: "Фенилаланин" },
    "Цистеин": { en: "Cysteine", ru: "Цистеин" },
    "Цистин": { en: "Cystine", ru: "Цистин" }
};

const unitTranslations = {
    "мг": "mg", "г": "g", "мл": "ml", "мкг": "µg",
    "МЕ": "IU", "ккал": "kcal", "кДж": "kJ",
    "%": "%", "кг": "kg", "л": "l",
    "шт": "pcs", "ч.л": "tsp", "ст.л": "tbsp"
};

const vitaminTranslations = {
    "Витамин А": { en: "Vitamin A", ru: "Витамин А" },
    "Витамин В1": { en: "Vitamin B1", ru: "Витамин В1" },
    "Витамин В2": { en: "Vitamin B2", ru: "Витамин В2" },
    "Витамин С": { en: "Vitamin C", ru: "Витамин С" }
};

const fattyAcidTranslations = {
    "Насыщенные ЖК": { en: "Saturated Fatty Acids", ru: "Насыщенные ЖК" },
    "Мононенасыщенные ЖК": { en: "Monounsaturated Fatty Acids", ru: "Мононенасыщенные ЖК" },
    "Полиненасыщенные ЖК": { en: "Polyunsaturated Fatty Acids", ru: "Полиненасыщенные ЖК" },
    "Насыщенные жирные кислоты, %": { en: "Saturated fatty acids, %", ru: "Насыщенные жирные кислоты, %" },
    "Капроновая": { en: "Caproic", ru: "Капроновая" },
    "Лауриновая": { en: "Lauric", ru: "Лауриновая" },
    "Миристиновая": { en: "Myristic", ru: "Миристиновая" },
    "Пальмитиновая": { en: "Palmitic", ru: "Пальмитиновая" },
    "Пальмитолеиновая": { en: "Palmitoleic", ru: "Пальмитолеиновая" },
    "Стеариновая": { en: "Stearic", ru: "Стеариновая" },
    "Арахиновая": { en: "Arachidic", ru: "Арахиновая" },
    "Бегеновая": { en: "Behenic", ru: "Бегеновая" },
    "Лигноцериновая": { en: "Lignoceric", ru: "Лигноцериновая" },
    "Маргариновая": { en: "Margaric", ru: "Маргариновая" },
    "Маргаринолеиновая": { en: "Margaroleic", ru: "Маргаринолеиновая" },
    "Пентадекановая": { en: "Pentadecanoic", ru: "Пентадекановая" },
    "Генейкозановая": { en: "Heneicosanoic", ru: "Генейкозановая" },
    "Трикозановая": { en: "Tricosanoic", ru: "Трикозановая" },
    "Октадеценовая": { en: "Octadecenoic", ru: "Октадеценовая" },
    "Олеиновая": { en: "Oleic", ru: "Олеиновая" },
    "Линолевая": { en: "Linoleic", ru: "Линолевая" },
    "Линоленовая": { en: "Linolenic", ru: "Линоленовая" },
    "Докозагексаеновая": { en: "Docosahexaenoic (DHA)", ru: "Докозагексаеновая" },
    "Докозадиеновая": { en: "Docosadienoic", ru: "Докозадиеновая" },
    "Эйкозатриеновая": { en: "Eicosatrienoic", ru: "Эйкозатриеновая" },
    "Эйкозотриеновая": { en: "Eicosatrienoic", ru: "Эйкозотриеновая" },
    "Эйкозеновая": { en: "Eicosenoic", ru: "Эйкозеновая" },
    "Селахолевая": { en: "Selacholeic", ru: "Селахолевая" },
    "Эруковая": { en: "Erucic", ru: "Эруковая" },
    "С4:0 масляная": { en: "C4:0 Butyric", ru: "С4:0 масляная" },
    "С6:0 капроновая": { en: "C6:0 Caproic", ru: "С6:0 капроновая" },
    "С8:0 каприловая": { en: "C8:0 Caprylic", ru: "С8:0 каприловая" },
    "С10:0 каприновая": { en: "C10:0 Capric", ru: "С10:0 каприновая" },
    "С11:0 ундекановая": { en: "C11:0 Undecanoic", ru: "С11:0 ундекановая" },
    "С12:0 лауриновая": { en: "C12:0 Lauric", ru: "С12:0 лауриновая" },
    "С13:0 тридекановая": { en: "C13:0 Tridecanoic", ru: "С13:0 тридекановая" },
    "С14:0 миристиновая": { en: "C14:0 Myristic", ru: "С14:0 миристиновая" },
    "С15:0 пентадекановая": { en: "C15:0 Pentadecanoic", ru: "С15:0 пентадекановая" },
    "С16:0 пальмитиновая": { en: "C16:0 Palmitic", ru: "С16:0 пальмитиновая" },
    "С17:0 маргариновая": { en: "C17:0 Margaric", ru: "С17:0 маргариновая" },
    "С18:0 стеариновая": { en: "C18:0 Stearic", ru: "С18:0 стеариновая" },
    "С20:0 арахиновая": { en: "C20:0 Arachidic", ru: "С20:0 арахиновая" },
    "С21:0 генейкозановая": { en: "C21:0 Heneicosanoic", ru: "С21:0 генейкозановая" },
    "С22:0 бегеновая": { en: "C22:0 Behenic", ru: "С22:0 бегеновая" },
    "С23:0 трикозановая": { en: "C23:0 Tricosanoic", ru: "С23:0 трикозановая" },
    "Пальмитиновой к лауриновой": { en: "Palmitic to Lauric", ru: "Пальмитиновой к лауриновой" },
    "Стеариновой к лауриновой": { en: "Stearic to Lauric", ru: "Стеариновой к лауриновой" },
    "Олеиновой к миристиновой": { en: "Oleic to Myristic", ru: "Олеиновой к миристиновой" },
    "Линолевой к миристиновой": { en: "Linoleic to Myristic", ru: "Линолевой к миристиновой" },
    "суммы олеиновой и линолевой к сумме лауриновой, миристиновой, пальмитиновой и стеариновой": {
        en: "Sum of oleic and linoleic to sum of lauric, myristic, palmitic and stearic",
        ru: "суммы олеиновой и линолевой к сумме лауриновой, миристиновой, пальмитиновой и стеариновой"
    },
    "Прочие (жирные кислоты)": { en: "Other (fatty acids)", ru: "Прочие (жирные кислоты)" }
};

// --- ОСНОВНОЙ КОМПОНЕНТ ---

export default function ProductDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const API = process.env.REACT_APP_API_URL;

    const { t, i18n } = useTranslation();
    const lang = i18n.language || 'ru';
    const tUnit = (unit) => lang === 'en' ? (unitTranslations[unit] || unit) : unit;

    useEffect(() => {
        const currentLang = i18n.language || 'ru';
        const fetchDetail = fetch(`${API}/product/details/${id}?lng=${currentLang}`).then(res => res.json());
        const fetchRecipe = fetch(`${API}/recipe/${id}`).then(res => res.json());

        Promise.all([fetchDetail, fetchRecipe])
            .then(([detailData, recipeData]) => {

                console.log('Данные из API получены:');
                console.log('Детали продукта (detailData):', detailData);

                setData({ detail: detailData, recipe: recipeData });
            })
            .catch(err => setError(err.message))
            .finally(() => setLoading(false));
    }, [id, i18n.language, API]);

    if (loading) return <p className="pd-loading">{t('loading')}</p>;
    if (error) return <p className="pd-error">{t('error_message', { error })}</p>;

    const { detail, recipe } = data;

    return (
        <div className="product-detail">
            <button className="back-btn" onClick={() => navigate(-1)}>
                ← {t('back')}
            </button>

            <div className="title-container">
                <h1 className="title">{detail.name}</h1>
                {recipe.ingredients && recipe.ingredients.length > 0 && (
                    <button className="recipe-btn" onClick={() => navigate(`/recipe/${id}`)}>
                        {t('view_recipe')}
                    </button>
                )}
            </div>

            <p className="subtitle">
                {regionTranslations[detail.regionName]?.[lang] || detail.regionName} · {categoryTranslations[detail.categoryName]?.[lang] || detail.categoryName}
            </p>

            {detail.chemicalComposition?.length > 0 && (
                <section>
                    <h2 className="section-title">{t('chemical_composition')}</h2>
                    <table className="comp-table">
                        <thead>
                        <tr>
                            <th>{t('substance')}</th>
                            <th>{t('quantity')}</th>
                            <th>{t('per_100g')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {detail.chemicalComposition.map(c => (
                            <tr key={c.id}>
                                <td>{nutrientTranslations[c.compoundName]?.[lang] || c.compoundName}</td>
                                <td>{c.error !== 0 && c.error != null? `${c.quantity} ± ${c.error}` : c.quantity}</td>
                                <td>{tUnit(c.unit)}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </section>
            )}

            {/* МИНЕРАЛЬНЫЙ СОСТАВ */}
            {detail.mineralComposition?.length > 0 && (
                <section>
                    <h2 className="section-title">{t('mineral_composition')}</h2>
                    <table className="comp-table">
                        <thead>
                        <tr>
                            <th>{t('mineral')}</th>
                            <th>{t('quantity')}</th>
                            <th>{t('per_100g')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {detail.mineralComposition.map(m => (
                            <tr key={m.id}>
                                <td>{mineralTranslations[m.mineral]?.[lang] || m.mineral}</td>
                                <td>{m.error !== 0 && m.error != null? `${m.quantity} ± ${m.error}` : m.quantity}</td>
                                <td>{tUnit(m.unit)}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </section>
            )}

            {/* ВИТАМИНЫ (НОВЫЙ БЛОК) */}
            {detail.vitaminComposition?.length > 0 && (
                <section>
                    <h2 className="section-title">{t('vitamin_composition')}</h2>
                    <table className="comp-table">
                        <thead>
                        <tr>
                            <th>{t('vitamin')}</th>
                            <th>{t('quantity')}</th>
                            <th>{t('per_100g')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {detail.vitaminComposition.map(v => (
                            <tr key={v.id}>
                                <td>{vitaminTranslations[v.vitaminName]?.[lang] || v.vitaminName}</td>
                                <td>{v.error !== 0 && v.error != null? `${v.quantity} ± ${v.error}` : v.quantity}</td>
                                <td>{tUnit(v.unit || 'мг')}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </section>
            )}

            {/* АМИНОКИСЛОТЫ (НОВЫЙ БЛОК) */}
            {detail.aminoAcidComposition?.length > 0 && (
                <section>
                    <h2 className="section-title">{t('amino_acid_composition')}</h2>
                    <table className="comp-table">
                        <thead>
                        <tr>
                            <th>{t('amino_acid')}</th>
                            <th>{t('quantity')}</th>
                            <th>{t('per_100g')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {detail.aminoAcidComposition.map(a => (
                            <tr key={a.id}>
                                <td>{aminoAcidTranslations[a.aminoAcidName]?.[lang] || a.aminoAcidName}</td>
                                <td>{a.error !== 0 && a.error != null? `${a.quantity} ± ${a.error}` : a.quantity}</td>
                                <td>{tUnit(a.unit)}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </section>
            )}

            {/* ЖИРНЫЕ КИСЛОТЫ (НОВЫЙ БЛОК) */}
            {detail.fattyAcidComposition?.length > 0 && (
                <section>
                    <h2 className="section-title">{t('fatty_acid_composition')}</h2>
                    <table className="comp-table">
                        <thead>
                        <tr>
                            <th>{t('fatty_acid')}</th>
                            <th>{t('type')}</th>
                            <th>{t('quantity')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {detail.fattyAcidComposition.map(f => (
                            <tr key={f.id}>
                                <td>{fattyAcidTranslations[f.fattyAcidName]?.[lang] || f.fattyAcidName}</td>
                                <td>{fattyAcidTranslations[f.typeOfFattyAcid]?.[lang] || f.typeOfFattyAcid}</td>
                                <td>{f.quantity} %</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </section>
            )}

            {detail.fattyAcidMethylEsterRatios?.length > 0 && (
                <section>
                    <h2 className="section-title">{t('fattyAcidMethylEsterRatios')}</h2>
                    <table className="comp-table">
                        <thead>
                        <tr>
                            <th>{t('ratio')}</th>
                            <th>{t('quantity')}</th>
                            <th>{t('per_100g')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {detail.fattyAcidMethylEsterRatios.map(far => (
                            <tr key={far.id}>
                                <td>{fattyAcidTranslations[far.ratioName]?.[lang] || far.ratioName}</td>
                                <td>{far.quantity}</td>
                                <td>{tUnit(far.unit)}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </section>
            )}
        </div>
    );
}